import { LogoMark } from "@/components/Logo";
import { scrollToId } from "@/App";

const LINKS = [
  { label: "Why Pickleball", href: "#why" },
  { label: "What We Deliver", href: "#deliver" },
  { label: "Court Specs", href: "#dimensions" },
  { label: "Event Ideas", href: "#ideas" },
  { label: "Add-ons", href: "#addons" },
  { label: "Process", href: "#process" },
  { label: "FAQ", href: "#faq" },
  { label: "Get a Quote", href: "#quote" },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-carbon" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <LogoMark size={44} />
              <p className="font-display text-2xl font-extrabold uppercase tracking-tight text-white">
                PopUp <span className="text-volt">Pickleball</span>
              </p>
            </div>
            <p className="mt-4 max-w-sm text-sm text-white/50">
              Portable pickleball courts with top-of-the-range JOOLA surfacing for events, activations and spaces
              across Melbourne & Victoria. Delivered, set up and hosted — all you do is play.
            </p>
            <a
              href="mailto:popuppickles@gmail.com"
              data-testid="footer-contact-email"
              className="mt-4 inline-block font-mono text-sm tracking-wider text-volt hover:underline"
            >
              popuppickles@gmail.com
            </a>
            <a
              href="tel:0434879138"
              data-testid="footer-contact-phone"
              className="mt-2 block font-mono text-sm tracking-wider text-white/60 transition-colors hover:text-volt"
            >
              0434 879 138
            </a>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                onClick={() => scrollToId(l.href)}
                className="text-sm font-semibold text-white/60 transition-colors hover:text-volt"
              >
                {l.label}
              </button>
            ))}
          </nav>
        </div>
        <p className="mt-14 select-none whitespace-nowrap font-display text-[13vw] font-extrabold uppercase leading-none tracking-tight text-outline lg:text-[10vw]">
          PopUp Pickleball
        </p>
        <div className="mt-10 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 PopUp Pickleball. Melbourne, Australia.</p>
          <p className="font-mono tracking-[0.2em]">MELBOURNE METRO · REGIONAL VIC BY APPOINTMENT</p>
        </div>
      </div>
    </footer>
  );
}
